module.exports = __webpack_public_path__ + "static/media/cao-hac-sam-5.7fb3af5f.jpg";